import { render } from "./ForgotPassword.vue?vue&type=template&id=6eccfbf8&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=6eccfbf8&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eccfbf8"]])

export default __exports__